
<template>
  <div :class="$style.page">
    <!-- 搜索 -->
    <p :class="$style.title">
      查询结果
      <span :class="$style.title_desc">
        为了更好的保护品牌，推荐注册更多后缀的域名
      </span>
    </p>

    <Search
      page="result"
      :domainText="text"
      :domainSuffix="domainSuffixList"
      @fetchSuccess="fetchSuccess"
      @loading="setLoading"
      @isShow="setTsShow"
    />

    <!-- 查询结果列表 -->
    <p :class="$style.title">结果列表</p>

    <Loading :loading="loading">
      <div v-if="isShow">
        <el-empty description="限制注册！"></el-empty>
      </div>
      <template v-else>
        <div  :class="$style.list">
          <el-checkbox-group v-model="checkedList">
            <template v-for="(item, index) in showList">
              <div
                :key="index"
                :class="{
                  [$style.checkout_item]: true,
                  [$style.registered]: item.registerStatus === 1,
                }"
              >
                <!-- 未注册 -->
                <template v-if="item.registerStatus === 0">
                  <div :class="$style.item_left">
                    <el-checkbox :label="item">
                      {{ item.domainName }}
                    </el-checkbox>
                  </div>
                  <div :class="$style.item_right">
                    <span :class="$style.status">
                      {{ getRegisterStatus(item.registerStatus) }}
                    </span>
                    <span :class="$style.price">
                      {{ item.activityPrice }}元/首年
                    </span>
                    <el-button
                      :class="$style.item_btn"
                      @click="() => addShopping(item)"
                    >
                      加入购物车
                    </el-button>
                  </div>
                </template>

                <!-- 已注册 -->
                <template v-if="item.registerStatus === 1">
                  <div :class="$style.item_left">
                    <span :class="$style.name">{{ item.domainName }}</span>
                  </div>
                  <div :class="$style.item_right">
                    <span :class="$style.status">
                      {{ getRegisterStatus(item.registerStatus) }}
                    </span>
                  </div>
                </template>

                <!-- 查询失败 -->
                <template v-if="item.registerStatus === 2">
                  <div :class="$style.item_left">
                    <span :class="$style.name">{{ item.domainName }}</span>
                  </div>
                  <div :class="$style.item_right">
                    <span :class="$style.status">
                      {{ getRegisterStatus(item.registerStatus) }}
                    </span>
                    <span class="theme-color">{{ item.message }}</span>
                  </div>
                </template>
              </div>
            </template>
          </el-checkbox-group>

          <div v-if="!loading && showList.length === 0" :class="$style.no_more">
            暂无数据
          </div>
        </div>

        <!-- 底部操作按钮 -->
        <div v-if="showList.length > 0" :class="$style.bottom_btn">
          <el-checkbox
            v-model="isSelectAll"
            :disabled="canSelectList.length === 0"
            @change="onSelectAllChange"
          >
            全选
          </el-checkbox>
          <el-button :class="$style.btn_batch" @click="addShopping()">
            批量加入购物车
          </el-button>
        </div>
      </template>
    </Loading>

    <RightNav />
  </div>
</template>

<script>
import { mapState} from "vuex";
import Search from "../domain-register/components/Search.vue";
import RightNav from "@components/RightNav.vue";
import { createShopping, getTypeShopping} from "@server";

export default {
  name: "DomainSearch",
  components: { Search, RightNav },
  data() {
    return {
      text: "", // 搜索内容
      isSelectAll: false, // 是否全选

      loading: false,
      showList: [], // 查询域名列表
      checkedList: [], // 已选域名列表

      isShow:false
    };
  },
  computed: {
    ...mapState(["domainText", "domainSuffix"]),
    ...mapState("login", ["isLogin"]),
    canSelectList() {
      // 可选域名列表
      return this.showList.filter((i) => i.registerStatus === 0 && !i.hasAdd);
    },
  },
  watch: {
    canSelectList(val) {
      const _val = val.map((i) => i.domainName);
      this.checkedList = this.checkedList.filter((item) =>
        _val.includes(item.domainName)
      );
    },
    checkedList(val) {
      this.isSelectAll =
        val.length > 0 && val.length === this.canSelectList.length;
    },
  },
  created() {
    if(this.$route.query.text){
      this.text = this.$route.query.text
    }
    if(this.$route.query.checkFixList){
      this.domainSuffixList = JSON.parse(this.$route.query.checkFixList)
    }
  },
  methods: {

    setLoading(v) {
      this.loading = v;
    },
    setTsShow(val){
      this.isShow = val
    },

    async fetchSuccess(list) {
      await this.getRegisterShopping(list);
    },

    async addShopping(shop) {
      // shop存在即添加单个商品，不存在为批量添加
      if (!shop && this.checkedList.length === 0) {
        this.$message({ message: "请选择商品", type: "warning" });
        return;
      }

      if (shop?.hasAdd) {
        this.$message({ message: "该商品已加入购物车", type: "warning" });
        return;
      }

      this.loading = true;
      const tradeNames = shop
        ? [shop.domainName]
        : this.checkedList.map((item) => item.domainName);
      const data = {
        goodsNames: tradeNames,
        operateType: 0,
      };
      const res = await createShopping(data);

      if (res.code === 200) {
        this.$message({ message: "购物车添加成功", type: "success" });
        setTimeout(() => {
          this.$router.push("/cart");
        }, 1000);
      } else {
        this.$message({ message: "购物车添加失败", type: "error" });
      }
      this.loading = false;
    },

    async getRegisterShopping(showList) {
      // 请求购物车的域名注册，用于设置商品是否已被添加到购物车
      console.log(this.isLogin)
      this.showList = showList;
      if(this.isLogin) {
        const res = await getTypeShopping({ type: 0 });
        const { code, data } = res;

        if (code === 200) {
          if (data != null) {
            let filter = data.filter(item => {
              return item.status == 3
            })
            if (filter != null && filter.length > 0) {
              this.isShow = true
            }
          }
          const _cartList = data.map((i) => i.tradeName);
          const _showList = showList ? showList : [...this.showList];

          _showList.forEach((item) => {
            if (_cartList.includes(item.domainName)) {
              item.hasAdd = true;
            }
          });

          this.showList = _showList;
        }
      }
    },

    onSelectAllChange(isAll) {
      this.checkedList = isAll ? this.canSelectList : [];
    },

    getRegisterStatus(status) {
      const mapStatus = {
        0: "未注册",
        1: "已注册",
        2: "查询失败",
      };
      return mapStatus[status];
    },
  },
};
</script>

<style lang="scss" module scoped>
.page {
  width: rem(1200);
  margin: rem(40) auto rem(100);

  .title {
    padding: rem(40) 0;
    font-size: rem(24);
    font-weight: bold;
    color: #333;

    .title_desc {
      margin-left: rem(20);
      font-size: rem(14);
      color: #666;
    }
  }

  .input {
    @include flex();
    margin-bottom: rem(30);
  }

  :global {
    ::v-deep .el-input {
      height: rem(80);

      .el-input__inner {
        flex: 1;
        height: 100%;
        padding-left: rem(40);
        font-size: rem(14);
        background: #fff;
        border-color: $border-color;
        border-radius: 0;
        &:focus {
          border-color: $border-focus-color;
        }
      }

      .el-button {
        width: rem(200);
        height: rem(80);
        font-size: rem(22);
        font-weight: bold;
        color: #fff;
        background: $theme-color;
        border-radius: 0;

        &:hover {
          background: $theme-hover-color;
        }

        .el-icon-search {
          font-weight: $font-weight-regular;
          margin-right: rem(16);
        }

        > span {
          margin: 0;
        }
      }
    }

    ::v-deep .el-checkbox-group {
      background: #fff;

      .el-checkbox {
        width: 100%;
        padding: 5px 0;
        .el-checkbox__input {
          .el-checkbox__inner {
            border-radius: 50%;
          }
        }

        .el-checkbox__label {
          flex: 1;
          font-size: rem(16);
          color: #555;
          @include text-ellipsis(rem(120));
        }
      }
    }
  }

  .checkout_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: rem(80);
    padding: 0 rem(40);
    border-bottom: 1px solid #eee;

    font-size: rem(14);
    color: #555;

    .item_left {
      width: rem(360);
    }

    .item_right {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .name {
      padding-left: 26px;
    }

    .price {
      color: $theme-color;
    }

    .item_btn {
      width: rem(120);
      min-width: 80px;
      height: rem(46);
      padding: 0;
      font-size: 12px;
      color: #555;
      background: #fff;
      border-color: #ddd;
      border-radius: 2px;

      &:hover {
        color: #fff;
        background: $theme-color;
        border-color: $theme-color;
      }
    }

    &:hover {
      background: #eee;
    }

    &.registered {
      .status {
        color: #f00;
      }

      .item_btn {
        color: #fff;
        border-color: $theme-blue-color;
        background: $theme-blue-color;
        &:hover {
          color: #fff;
          border-color: $theme-hover-blue-color;
          background: $theme-hover-blue-color;
        }
      }
    }
  }

  .list {
    min-height: rem(300);
    background: $white;

    .no_more {
      width: 100%;
      height: rem(300);
      font-size: rem(14);
      color: #909399;
      @include flex();
    }
  }

  .bottom_btn {
    margin-top: rem(50);
    padding-left: rem(40);

    :global {
      ::v-deep .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            border-radius: 50%;
          }
        }

        .el-checkbox__label {
          font-size: rem(14);
          color: #333;
          padding-left: rem(20);
        }
      }
    }

    .btn_batch {
      width: rem(140);
      min-width: 100px;
      height: rem(46);
      padding: 0;
      margin-left: 30px;
      font-size: 12px;
      color: #fff;
      background: $theme-color;
      border-radius: 2px;

      &:hover {
        background: $theme-hover-color;
      }
    }
  }
}
</style>
